// Единый источник новостей.
// Сюда сведены данные, которые раньше дублировались в VMainNews, VNews и каталоге.
// В будущем массив можно заменить на загрузку с API (напр. async fetchNews() + хук
// useNews() с состоянием loading/data), не трогая компоненты — они обращаются к
// данным только через экспортируемые `news` / `getNewsById`.
//
// Структура пункта: { id, date, img_url_prev, img_url_main, title, content(HTML), featured }.
// Порядок — новейшие сверху.
// featured: true — новость показывается в блоке «Новости» на главной странице.
// Остальные новости видны только на странице «Новости» (/news).

export const news = [
  {
    id: 13,
    date: '08 июня 2026',
    img_url_prev: '13_prev.png',
    img_url_main: '13_main.jpg',
    featured: true,
    title: "Акция — выгода для всей семьи!",
    content: `<b>Вода Calipso — польза и выгода для всей семьи!</b></br>Акция действует <b style="color: #0060B7">с 8 по 30 июня 2026 года</b>.</br></br><strong>При заказе 6 бутылей (18,9 л)</strong> — мы дарим помпу для воды!</br></br><strong>Покупаете 5 бутылей (18,9 л) — платите за 5, а получаете 6 бутылей!</strong></br>(только по предоплате, оплачиваете 5 бутылей воды)</br></br><strong>Закажите 8 бутылей (18,9 л)</strong> — и мы дарим вам упаковку воды 0,5 л (12 шт, негазированная)!</br></br>Оплата за тару производится отдельно.`
  },
  {
    id: 12,
    date: '28 декабря 2025',
    img_url_prev: '12_prev.svg',
    img_url_main: '12_main.svg',
    featured: true,
    title: "Повышение цен с 1 января 2026",
    content: `Уважаемый клиент!</br></br>Calipso благодарит Вас за сотрудничество, выражает глубокую признательность за верность и доверие, которое Вы оказываете нам, в течение многих лет.</br></br>В течение 3-4 квартала 2025 года на мировом рынке мы наблюдаем значительное удорожание упаковочных материалов. Поставщики значительно увеличили цены на используемое нами в производстве сырье при выпуске бутилированной питьевой воды (Стрейч пленка, полиэтиленовые пакеты, скотч, ПЭТ преформы, крышки, этикетки, бутыль (тара) 18,9 л. и прочее: ставка НДС увеличивается до 16%, энергоносители, ГСМ и другие).</br></br>В виду сложившейся ситуации, <b style="color: red">с 1 января 2026 года</b> мы вынуждены были принять непростое для нас решение о повышении отпускных цен на воду объемом 18,9л., объемом 0,5-5л, обменную тару, пересмотреть стоимость на предоплату, услуги промывки и ремонта диспенсеров.</br></br>Просим Вас с пониманием отнестись к сложившейся ситуации.</br></br>Для уточнения цены на продукцию, просим Вас связаться с менеджерами ТОО «КОМЕТА» по следующим телефонам:</br><b>+7 (771) 929-22-88</b> нажать цифру 1</br></br>С уважением,</br>Команда Calipso`
  },
  {
    id: 11,
    date: '27 декабря 2025',
    img_url_prev: '11_prev.svg',
    img_url_main: '11_main.svg',
    title: "С наступающим Новым годом!",
    content: `Дорогие клиенты!</br></br>Поздравляем Вас с наступающим Новым годом!</br>Спасибо, что в этом году Вы были с нами и доверяли нам. Пусть новый год принесёт Вам радость, стабильность, вдохновение и новые возможности.</br></br>Желаем здоровья, благополучия и исполнения самых заветных желаний.</br></br><strong>График работы в праздничные дни:</strong></br>• С 1 по 4 января — выходные дни</br>• 5-6 января — рабочие дни</br>• 7 января — выходной день</br></br>Пожалуйста, оформляйте заказы заранее, чтобы мы успели доставить воду до праздников.</br></br>До встречи в новом году!</br>С уважением, команда Calipso 💙`
  },
  {
    id: 10,
    date: '11 декабря 2025',
    img_url_prev: '10_prev.svg',
    img_url_main: '10_main.svg',
    title: "Выходной день 16 декабря",
    content: `Уважаемые покупатели! </br>В связи с празднованием Дня независимости 16 декабря - у нас будет выходной день. Просим учитывать это при оформлении заказов на доставку воды. Благодарим за понимание! </br></br>Құрметті сатып алушылар!</br> Тәуелсіздік күніне байланысты 16 желтоқсан - бізде демалыс күні болады. Суды жеткізуге тапсырыс берген кезде осыны ескерулеріңізді сұраймыз. Түсіністік танытқандарыңызға рақмет!`
  },
  {
    id: 9,
    date: '23 сентября 2025',
    img_url_prev: '09_prev.jpg',
    img_url_main: '09_main.jpg',
    title: "Повышение цен на питьевую воду",
    content: `С 01 октября 2025 года на питьевую воду установлены новые цены. Качество нашей продукции остается неизменно высоким, а уровень предоставляемых услуг продолжает соответствовать высоким стандартам. Ознакомьтесь, пожалуйста, с актуальным прайс-листом, размещенным в нашем каталоге, и выберите продукцию, отвечающую вашим потребностям. </br></br>Благодарим Вас за доверие и выбор нашей компании!`
  },
  // {
  //   id: 8,
  //   date: '01 февраля 2025',
  //   img_url_prev: '08_prev.png',
  //   img_url_main: '08_main.png',
  //   title: "Повышение цен на питьевую воду",
  //   content: `С 1 февраля 2025 года на питьевую воду установлены новые цены. Качество нашей продукции остается неизменно высоким, а уровень предоставляемых услуг продолжает соответствовать высоким стандартам. Ознакомьтесь, пожалуйста, с актуальным прайс-листом, размещенным в нашем каталоге, и выберите продукцию, отвечающую вашим потребностям. </br></br>Благодарим Вас за доверие и выбор нашей компании!`
  // },
  // {
  //   id: 7,
  //   date: '30 декабря 2024',
  //   img_url_prev: '07_prev.png',
  //   img_url_main: '07_main.png',
  //   title: "График работы в праздничные дни",
  //   content: `Дорогие друзья! Поздравляем Вас с наступающим Новым годом! Пусть этот год принесет Вам множество ярких и счастливых моментов. Пусть каждый день будет наполнен радостью, гармонией и благополучием. Мы благодарны за Ваше доверие и поддержку в уходящем году и с нетерпением ждем новых встреч в 2025 году!</br></br>В связи с праздниками,  <b style="color: red";>с 1 по 3 января и 7 января 2025 года</b> доставка заказов на сайте будет временно  <b style="color: red";>недоступна</b>. Благодарим за понимание и желаем Вам чудесных праздников, наполненных счастьем и радостью! Пусть в эти волшебные дни сбудутся все Ваши мечты!`
  // },
  {
    id: 6,
    date: '01 июня 2024',
    img_url_prev: '06_prev.png',
    img_url_main: '06_main.png',
    title: "С Днём защиты детей!",
    content: `Пусть этот день будет наполнен радостью и смехом детей, их беззаботностью и счастьем. Пусть каждый ребёнок почувствует заботу и внимание вокруг себя, пусть каждый малыш знает, что он ценен и важен для нас всех.
    \nЖелаем Вам и Вашим детям здоровья, мира и благополучия. Пусть каждый ребёнок растёт в любви и заботе, пусть его детство будет наполнено яркими впечатлениями и радостными моментами.
    \nС праздником, дорогие друзья!`
  },
  {
    id: 5,
    date: '31 мая 2024',
    img_url_prev: '05_prev.png',
    img_url_main: '05_main.png',
    title: "Скидка 20% на кулеры до конца июня!",
    content: `Не упустите свой шанс приобрести лучшие кулеры по выгодной цене. Скидка 20% действует только до конца месяца! Спешите, количество товара ограничено!

    <b style="color: red";>Акция действует с 1 июня по 1 июля.</b>`
  },
  {
    id: 4,
    date: '09 мая 2024',
    img_url_prev: '04_prev.png',
    img_url_main: '04_main.png',
    title: "С Днём Победы!",
    content: `Этот день напоминает нам о героических подвигах наших предков, о их бесстрашии и самопожертвовании в борьбе за свободу и мир.
    \nСегодня мы отдаём должное Всем тем, кто сражался и погиб за наше будущее, за мирное небо над головой. Этот день единства и памяти наполнен гордостью за победу и скорбью о потерянных.
    \nПусть этот праздник напоминает нам о ценности мира и единства, о необходимости беречь и уважать друг друга, строить будущее на основе мира и гармонии.

    \nС праздником Великой Победы!`
  },
  // {
  //   id: 3,
  //   date: '07 мая 2024',
  //   img_url_prev: '03_prev.png',
  //   img_url_main: '03_main.png',
  //   title: "График работы в праздничные дни",
  //   content: `Уважаемые клиенты!
  //   \n Мы хотим сообщить Вам, что в период <b>с 7 по 9 мая включительно</b> наша компания <b>не будет работать</b> в связи с празднованием Дня Победы. В эти дни мы не будем осуществлять прием и доставку заказов.
  //   \nПожалуйста, заранее позаботьтесь о своих заказах, чтобы избежать возможных неудобств.
  //   \nС 10 мая мы продолжим работу в обычном режиме и будем рады вновь обслуживать Вас.
  //   \nСпасибо за понимание!`
  // },
  {
    id: 2,
    date: '07 мая 2024',
    img_url_prev: '02_prev.png',
    img_url_main: '02_main.png',
    title: "С днем защитника отечества!",
    content: `Поздравляем Вас с наступающим важным и гордым для нашей страны днём - Днём Защитника Отечества! Пусть эта дата напоминает нам о силе, единстве и гордости за нашу Родину. Пусть каждый из нас будет защитником своей семьи, своего дома и нашей родной земли.`
  },
  {
    id: 1,
    date: '01 мая 2024',
    img_url_prev: '01_prev.png',
    img_url_main: '01_main.png',
    title: "Поздравляем с Днем Единства!",
    content: `1 Мая - день, когда мы отмечаем нашу силу в единстве и совместные усилия. Пусть этот день напомнит нам о важности сотрудничества и общих целей. Желаем Вам вдохновения, новых свершений и взаимной поддержки во всех начинаниях!
              \n Пусть каждый новый день принесет в Ваши жизни радость и успехи, а наша работа будет приносить плоды и удовлетворение. Давайте вместе двигаться к общим целям и строить лучшее будущее!
              \n С праздником, дорогие друзья!`
  }
]

// Новости для блока на главной (помеченные featured: true).
export const featuredNews = news.filter((item) => item.featured);

// Найти новость по id.
export const getNewsById = (id) => news.find((item) => item.id === id);

// id новости о повышении цен — на неё ссылается каталог.
export const PRICE_NEWS_ID = 12;
